module.exports = __webpack_public_path__ + "static/diana-vahos-morado-51ea295fc4200806e18e4aeb54024692.png";